import React, { useEffect, useState } from "react";

function TreeNode({
  node,
  onAdd,
  onEdit,
  onDelete,
  selected,
  onSelect,
  openWareHouseModal,
  onLoadChildren,
}) {
  const [open, setOpen] = useState(false);

  const hasChildren =
    node.nodeType === "category" &&
    (node.childCount > 0 || node.warehouseCount > 0);
  const isWarehouse = node.nodeType === "warehouse";
  const hasWarehouseCount = node.warehouseCount > 0;
  const warehouseCount = node.warehouseCount;
  const childCount = node.childCount;

  const toggleOpen = async (e) => {
    e.stopPropagation();

    if (!open && hasChildren && node.children === null) {
      await onLoadChildren(node);
    }

    setOpen((prev) => !prev);
  };

  useEffect(() => {
    if (node.children === null) {
      setOpen(false);
    }
  }, [node.children]);

  function isShowWarHouse() {
    let show = false;
    if (node.nodeType === "category") {
      if (childCount === 0) {
        show = true;
      }
    }

    return show;
  }

  return (
    <div style={{ marginRight: "1rem" }} dir="rtl">
      {/* Row */}
      <div
        className="d-flex align-items-center justify-content-between py-1 px-1 rounded"
        onClick={() => onSelect?.(node)}
        style={{ cursor: "pointer" }}
      >
        {/* Expand + Label */}
        <div className="d-flex align-items-center gap-2">
          {/* Toggle icon */}
          {hasChildren ? (
            <i
              className={`bi ${
                open ? "bi-chevron-down" : "bi-chevron-left"
              } text-primary`}
              onClick={toggleOpen}
              style={{ cursor: "pointer" }}
            ></i>
          ) : (
            <i
              className="bi bi-dash text-muted"
              style={{ width: "1rem", cursor: "default" }}
            ></i>
          )}

          {/* Label */}
          <span
            className="fw-medium"
            style={{
              marginLeft: "20px",
              cursor: hasChildren ? "pointer" : "default",
            }}
            onClick={(e) => {
              if (!hasChildren) return;
              toggleOpen(e);
            }}
          >
            {node.label}
          </span>

          {/* Inline actions */}
          <div className="d-flex align-items-center mr-3 gap-3 opacity-0 group-hover-opacity">
            <i
              className="bi bi-pencil text-success"
              onClick={(e) => {
                e.stopPropagation();

                if (node.nodeType === "warehouse") {
                  openWareHouseModal?.(node); // EDIT warehouse
                } else {
                  onEdit?.(node); // EDIT category
                }
              }}
            ></i>
            {!hasWarehouseCount && node.nodeType === "category" && (
              <i
                className="bi bi-plus-circle text-primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onAdd?.(node);
                }}
              ></i>
            )}
            {!hasChildren && (
              <i
                className="bi bi-trash3 text-danger"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.(node);
                }}
              ></i>
            )}
          </div>
        </div>
        {/* Add warehouse */}
        {isShowWarHouse() && (
          <div className="d-flex align-items-center gap-3 opacity-0 group-hover-opacity">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                openWareHouseModal?.(node);
              }}
              className="btn btn-outline-purple custome-btn"
            >
              {"افزودن انبار"}

              <span className="ms-1">
                <i className="bi bi-plus-circle align-middle"></i>
              </span>
            </button>
          </div>
        )}
      </div>

      {/* Children */}
      {open && node.children && (
        <div
          style={{
            borderRight: "1px solid #ccc",
            marginRight: "1.2rem",
            paddingRight: "0.8rem",
            marginTop: "0.3rem",
          }}
        >
          {node.children.map((child) => (
            <TreeNode
              key={child.id}
              node={child}
              onLoadChildren={onLoadChildren}
              openWareHouseModal={openWareHouseModal}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              selected={selected}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default TreeNode;
